import { QuestionKey } from '@hb/modules/global/global.constants';
import { AdditionalInfoComponent } from '@hb/modules';
import { StartersDispensationButtonComponent } from '@hb/modules/applicants/starters-dispensation/starters-dispensation-button/starters-dispensation-button.component';

import { Component } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentModule } from '@ap/content';

@Component({
    selector: 'starters-dispensation',
    templateUrl: './starters-dispensation.component.html',
    standalone: true,
    imports: [ApContentModule, ReactiveFormsModule, AdditionalInfoComponent, StartersDispensationButtonComponent]
})
export class StartersDispensationComponent {
    readonly questionKey = QuestionKey.INCOME_STARTERS_DISPENSATION;
}
